export default "__VITE_ASSET__DyaEVR9g__"